import { LoanApplicationService } from "../../services/LoanApplication";
import { CustomLoaderFunctionArgs } from "../../shared/router/RouteLoader";

export async function loader({
  params,
  getToken,
  pageName
}: CustomLoaderFunctionArgs) {
  const { loanID, sourceEntityID } = params;

  if (loanID) {
    const token = getToken();
    const [manualCreditReviewResponse, workflowResponse, softApprovalResponse] =
      await Promise.all([
        LoanApplicationService.getManualCreditReviewDetails({
          loanApplicationID: loanID,
          token,
          pageName: pageName!,
          sourceEntityID: sourceEntityID as string
        }),
        LoanApplicationService.getWorkflows({
          loanApplicationID: loanID,
          token,
          pageName: pageName!
        }),
        LoanApplicationService.workflowSoftApproval({
          loanApplicationID: loanID,
          token,
          pageName: pageName!,
          sourceEntityID: sourceEntityID as string
        })
      ]);

    return {
      manualCreditReviewResponse,
      workflowResponse,
      softApprovalResponse
    };
  }

  return {
    manualCreditReviewResponse: { data: [] },
    workflowResponse: { data: {} },
    softApprovalResponse: { data: {} }
  };
}
